import { observer } from "mobx-react";
import { FormField } from "../../../../../../components/form-field/form-field";
import TranslationInput from "../../../../../../translation/translation-input/translation-input";
import { RETURNS_PORTAL_TRANSLATION_KEYS } from "../../constants";
import useTranslation from "../../../../../../translation/hooks/translation-hook";
import { useImperativeHandle } from "react";

export interface ILocateOrderGiftCardEntryRef {
    save: () => Promise<void>;
    discardChanges: () => void;
    hasChanges: () => boolean;
}

interface ILocateOrderGiftCardEntryProps {
    ref: React.RefObject<ILocateOrderGiftCardEntryRef>;
}

const LocateOrderGiftCardEntry: React.FC<ILocateOrderGiftCardEntryProps> = observer(({ ref }) => {
  const { hasChanges, discardChanges, save } = useTranslation();

    useImperativeHandle(ref, () => ({
        save: () => {
            if (hasChanges()) {
                return save();
            }

            return Promise.resolve();
        },
        discardChanges: () => {
            if (hasChanges()) {
                discardChanges();
            }
        },
        hasChanges: () => {
            return hasChanges();
        },
    }));

    return (
        <FormField label="Gift Return Link Text">
            <TranslationInput translationKey={RETURNS_PORTAL_TRANSLATION_KEYS.RETURNING_A_GIFT} />
        </FormField>
    );
});

export default LocateOrderGiftCardEntry;